export default __webpack_public_path__ + "static/media/menuL_icon_06.8190d762.png";